import sp1500 from '../static/sp1500.json';

import sgx100 from '../static/sgx100.json';
import hsi88 from '../static/hsi88.json';

// Add ticker field to each sgx100 entry
const sgx100WithTicker = sgx100.map(entry => ({
    ...entry,
    ticker: entry.company_id
})).sort((a, b) => 
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
);

const hsi88WithTicker = hsi88.map(entry => ({
    ...entry,
    ticker: entry.company_id
})).sort((a, b) => 
    a.name.toLowerCase().localeCompare(b.name.toLowerCase())
);


export const SP1500 = sp1500;
export const SGX100 = sgx100WithTicker;
export const HSI88 = hsi88WithTicker;

export function findCompanyAndFormatName(ticker, ticker_list="SP1500") {

    let matchedCompany = null;
    if (ticker_list === "SP1500") {
        // Find the company with matching ticker
        matchedCompany = SP1500.find(company => company.ticker === ticker);
    } else if (ticker_list === "SGX100") {
        // Find the company with matching ticker
        matchedCompany = SGX100.find(company => company.ticker === ticker);
    } else if (ticker_list === "HSI88") {
        // Find the company with matching ticker
        matchedCompany = HSI88.find(company => company.ticker === ticker);
    }
    // If company is found, title case its name
    if (matchedCompany) {
      matchedCompany = {...matchedCompany}; // Create a copy to avoid modifying the original
      matchedCompany.name = matchedCompany.name
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    return matchedCompany || null;
}

export function findCompanyByCik(cik) {
    // CIKs in SP1500 may be numbers or strings, so compare as strings
    return SP1500.find(company => String(company.cik) === String(cik)) || null;
}
